import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.signatureAreaPage.pageTitle',
    defaultMessage: 'Area firma',
    description: 'Title of the signature area page',
  },
  allSectionTitle: {
    id: 'features.signatureAreaPage.allSectionTitle',
    defaultMessage: 'Tutti',
    description: 'Title of "all" section in signature area page',
  },
  toSignSectionTitle: {
    id: 'features.signatureAreaPage.toSignSectionTitle',
    defaultMessage: 'Da firmare',
    description: 'Title of "to sign" section in signature area page',
  },
  expiringSectionTitle: {
    id: 'features.signatureAreaPage.expiringSectionTitle',
    defaultMessage: 'In scadenza',
    description: 'Title of "expiring" section in signature area page',
  },
  detailsLinkText: {
    id: 'features.signatureAreaPage.detailsLinkText',
    defaultMessage: 'dettagli',
    description: 'the link to open the detail of a document',
  },
  noDocumentsMessage: {
    id: 'features.signatureAreaPage.noDocumentsMessage',
    defaultMessage: 'Non sono presenti pratiche da firmare',
    description: 'message show when there are no documents',
  },
  noDocumentsMessageProspect: {
    id: 'features.signatureAreaPage.noDocumentsMessageProspect',
    defaultMessage:
      'I documenti di firma non sono ancora disponibili. Ritenta tra qualche minuto',
    description: 'message show when there are no documents',
  },
  practiceTitle: {
    id: 'features.signatureAreaPage.practiceTitle',
    defaultMessage: 'Pratica n° {practiceNumber}',
    description: 'message show when there are no documents',
  },
  mifidPracticeTitle: {
    id: 'features.signatureAreaPage.mifidPracticeTitle',
    defaultMessage: 'Questionario MIFID',
    description: 'message show when there are no documents',
  },
  amlPracticeTitle: {
    id: 'features.signatureAreaPage.amlPracticeTitle',
    defaultMessage: 'Questionario AML',
    description: 'message show when there are no documents',
  },
  asdPracticeTitle: {
    id: 'features.signatureAreaPage.asdPracticeTitle',
    defaultMessage: 'ADESIONE SERVIZI DIGITALI',
    description: 'message show when there are no documents',
  },
  changeContactPracticeTitle: {
    id: 'features.signatureAreaPage.changeContactPracticeTitle',
    defaultMessage: 'CAMBIO RECAPITO SERVIZI DIGITALI',
    description: 'message show when there are no documents',
  },
  dobPracticeTitle: {
    id: 'features.signatureAreaPage.dobPracticeTitle',
    defaultMessage: 'Onboarding Persona Fisica',
    description: 'message show when there are no documents',
  },

  /** document details texts */
  documentLabel: {
    id: 'features.signatureAreaPage.documentLabel',
    defaultMessage: 'Pratica ',
    description: 'Text that precedes the document name in the details',
  },
  TitleDocumentLabel: {
    id: 'features.signatureAreaPage.TitleDocumentLabel',
    defaultMessage: 'Pratica',
    description: 'Text that precedes the document name in the details',
  },
  clientLabel: {
    id: 'features.signatureAreaPage.clientLabel',
    defaultMessage: 'Cliente',
    description: 'Label that precedes the client name of the document',
  },
  titleLinkLabel: {
    id: 'features.signatureAreaPage.titleLinkLabel',
    defaultMessage: 'Titolo',
    description: 'Label that precedes the link for the pdf download',
  },
  amountLabel: {
    id: 'features.signatureAreaPage.amountLabel',
    defaultMessage: 'Importo',
    description: 'Label that precedes the amout of the document',
  },
  labelLinkToSign: {
    id: 'features.signatureAreaPage.labelLinkToSign',
    defaultMessage: 'da firmare',
    description: 'Label that precedes link to sign',
  },
  totalDocumentLabel: {
    id: 'features.signatureAreaPage.totalDocument',
    defaultMessage: 'Totale moduli proposta',
    description: 'Label that precedes the total document to sign',
  },
  totalDocumentLabelShort: {
    id: 'features.signatureAreaPage.totalDocument',
    defaultMessage: 'Tot. moduli proposta',
    description: 'Label that precedes the total document to sign',
  },
  acknowledgmentLabel: {
    id: 'features.signatureAreaPage.acknowledgment',
    defaultMessage: 'Presa visione',
    description: 'Acknowledgment label',
  },
  forwardLabel: {
    id: 'features.signatureAreaPage.forward',
    defaultMessage: 'Avanti',
    description: 'forward label',
  },
  signedLabel: {
    id: 'features.signatureAreaPage.forward',
    defaultMessage: 'Firmato',
    description: 'Signed label',
  },
  rejectLabel: {
    id: 'features.signatureAreaPage.reject',
    defaultMessage: 'Rifiuta',
    description: 'reject label',
  },

  goBackLabel: {
    id: 'features.signatureAreaPage.go.back',
    defaultMessage: 'Indietro',
    description: 'go back label',
  },

  consentLabel: {
    id: 'features.signatureAreaPage.consent',
    defaultMessage: 'Acconsento',
    description: 'Consent label',
  },

  /** document disclaimer texts */
  maxFundDisclaimer: {
    id: 'features.signatureAreaPage.maxFund',
    defaultMessage:
      'Dichiaro di aver preso visione e di accettare espressamente tutte le norme e le indicazioni riportate sui moduli dispositivi (qui messi a disposizione) e ai mandati conferiti attraverso la sottoscrizione degli stessi, così come i KIID di ciascun prodotto. In particolare, ai sensi dell’art. 1341 e 1342 c.c. - dichiaro di approvare specificatamente i paragrafi relativi a: “Profilo di rischio e di rendimento” e “Spese”. Dichiaro, infine, anche ai sensi del D.Lgs. 231/2007 così come successivamente modificato: di essere il titolare effettivo dell’operazione (dichiarazione valida solo per i clienti persone fisiche); ovvero che non è intervenuta alcuna modifica con riguardo al titolare effettivo già dichiarato e a voi reso noto al/dal soggetto incaricato del collocamento (dichiarazione valida solo per i clienti persone NON fisiche).',
    description: 'maxFund disclaimer',
  },

  basicConsultingDisclaimer: {
    id: 'features.signatureAreaPage.basicConsulting',
    defaultMessage:
      'Dichiaro di aver preso visione e di accettare espressamente tutte le norme e le indicazioni riportate sui moduli dispositivi (qui messi a disposizione) e ai mandati conferiti attraverso la sottoscrizione degli stessi, così come i KIID di ciascun prodotto. In particolare, ai sensi dell’art. 1341 e 1342 c.c. - dichiaro di approvare specificatamente i paragrafi relativi a: “Profilo di rischio e di rendimento” e “Spese”. Dichiaro, infine, anche ai sensi del D.Lgs. 231/2007 così come successivamente modificato: di essere il titolare effettivo dell’operazione (dichiarazione valida solo per i clienti persone fisiche); ovvero che non è intervenuta alcuna modifica con riguardo al titolare effettivo già dichiarato e a voi reso noto al/dal soggetto incaricato del collocamento (dichiarazione valida solo per i clienti persone NON fisiche).',
    description: 'basicConsulting disclaimer',
  },

  textFooterDisclaimer: {
    id: 'features.signatureAreaPage.footerDisclaimer',
    defaultMessage:
      'I prospetti informativi possono essere richiesti al proprio Consulente Finanziario e sono altresì resi disponibili sul sito internet di Gruppo ',
    description: 'footerDisclaimer',
  },
  linkFooterDisclaimer: {
    id: 'features.signatureAreaPage.linkFooterDisclaimer',
    defaultMessage: 'www.azimut.it',
    description: 'link footerDisclaimer',
  },

  /** table section */
  documentDetailDialogOperationTab: {
    id: 'features.signatureAreaPage.documentDetailDialogOperationTab',
    defaultMessage: 'Operazioni',
    description: 'the title of the fields mandate on the table',
  },
  documentDetailDialogInformationTab: {
    id: 'features.signatureAreaPage.documentDetailDialogInformationTab',
    defaultMessage: 'Informazioni',
    description: 'the title of the fields mandate on the table',
  },
  documentDetailDialogSignatoryTab: {
    id: 'features.signatureAreaPage.documentDetailDialogSignatoryTab',
    defaultMessage: 'Firmatari',
    description: 'the title of the fields mandate on the table',
  },

  /** Options table messages */
  documentDetailTableFieldsMandate: {
    id: 'features.signatureAreaPage.documentDetailTableFieldsMandate',
    defaultMessage: 'Mandato',
    description: 'the title of the fields mandate on the table',
  },
  documentDetailTableFieldsCompany: {
    id: 'features.signatureAreaPage.documentDetailTableFieldsCompany',
    defaultMessage: 'Società',
    description: 'the title of the fields company on the table',
  },
  documentDetailTableFieldsProduct: {
    id: 'features.signatureAreaPage.documentDetailTableFieldsProduct',
    defaultMessage: 'Prodotto',
    description: 'the title of the fields product on the table',
  },
  documentDetailTableFieldsOperation: {
    id: 'features.signatureAreaPage.documentDetailTableFieldsOperation',
    defaultMessage: 'Operazioni',
    description: 'the title of the fields Operation on the table',
  },
  documentDetailTableFieldsPaymetType: {
    id: 'features.signatureAreaPage.documentDetailTableFieldsPaymetType',
    defaultMessage: 'Tipo Pagamento',
    description: 'the title of the fields PaymetType on the table',
  },
  documentDetailTableFieldsImport: {
    id: 'features.signatureAreaPage.documentDetailTableFieldsImport',
    defaultMessage: 'Importo',
    description: 'the title of the fields Import on the table',
  },

  /** informations table messages */
  documentDetailTableFieldsDocument: {
    id: 'features.signatureAreaPage.documentDetailTableDocument',
    defaultMessage: 'Pratica',
    description: 'the title of the fields Document on the table',
  },
  documentDetailTableFieldsDocumentNumber: {
    id: 'features.signatureAreaPage.documentDetailTableDocumentNumber',
    defaultMessage: 'N.pratica',
    description: 'the title of the fields DocumentNumber on the table',
  },
  documentDetailTableFieldsDispositionRTO: {
    id: 'features.signatureAreaPage.documentDetailTableDisposition',
    defaultMessage: 'Disposizione/RTO',
    description: 'the title of the fields Disposition on the table',
  },
  documentDetailTableFieldsExpiryDate: {
    id: 'features.signatureAreaPage.documentDetailTableExpiryDate',
    defaultMessage: 'Data di Scadenza',
    description: 'the title of the fields ExpiryDate on the table',
  },

  /** signatory table messages */
  documentDetailTableFieldsSignatory: {
    id: 'features.signatureAreaPage.documentDetailTableSignatory',
    defaultMessage: 'Cliente',
    description: 'the title of the fields Signatory on the table',
  },
  documentDetailTableFieldsFinancialAdvisor: {
    id: 'features.signatureAreaPage.documentDetailTableFinancialAdvisor',
    defaultMessage: 'Consulente Finanziario',
    description: 'the title of the fields FinancialAdvisor on the table',
  },

  /** Rto checks */
  rtoChecksHeaderTableName: {
    id: 'features.signatureAreaPage.rtoChecksHeaderTableName',
    defaultMessage: 'Nome titolo',
    description: 'Header label  of title name of table in rto checks',
  },
  rtoChecksHeaderTableNIsinCode: {
    id: 'features.signatureAreaPage.rtoChecksHeaderTableNIsinCode',
    defaultMessage: 'Codice ISIN',
    description: 'Header label  of ISIN code of table in rto checks',
  },
  rtoChecksHeaderTableTool: {
    id: 'features.signatureAreaPage.rtoChecksHeaderTableTool',
    defaultMessage: 'Strumento',
    description: 'Header label  of tool of table in rto checks',
  },
  rtoChecksHeaderTableOwner: {
    id: 'features.signatureAreaPage.rtoChecksHeaderTableOwner',
    defaultMessage: 'Intestatario',
    description: 'Header label  of owner of table in rto checks',
  },
  rtoChecksHeaderTableQuantity: {
    id: 'features.signatureAreaPage.rtoChecksHeaderTableQuantity',
    defaultMessage: 'Quantità',
    description: 'Header label  of quantity of table in rto checks',
  },
  rtoChecksHeaderTablePriceLimit: {
    id: 'features.signatureAreaPage.rtoChecksHeaderTablePriceLimit',
    defaultMessage: 'Prezzo limite',
    description: 'Header label  of Price limit of table in rto checks',
  },
  rtoChecksHeaderTablePriceMode: {
    id: 'features.signatureAreaPage.rtoChecksHeaderTablePriceMode',
    defaultMessage: 'Modalità prezzo',
    description: 'Header label  of price mode of table in rto checks',
  },
  rtoChecksHeaderTableValidity: {
    id: 'features.signatureAreaPage.rtoChecksHeaderTableValidity',
    defaultMessage: 'Validità',
    description: 'Header label  of Validity of table in rto checks',
  },
  rtoChecksAcknowledgmentLabel: {
    id: 'features.signatureAreaPage.rtoChecksAcknowledgmentLabel',
    defaultMessage: 'Dichiaro di aver preso visione di',
    description: 'Acknowledgment label',
  },
  rtoChecksAppropriatenessOutcomeLabel: {
    id: 'features.signatureAreaPage.rtoChecksAppropriatenessOutcomeLabel',
    defaultMessage: 'Esito appropriatezza',
    description: 'Appropriateness outcome label',
  },
  rtoChecksComplexLabel: {
    id: 'features.signatureAreaPage.rtoChecksComplexLabel',
    defaultMessage: 'Complesso',
    description: 'Complex label',
  },
  rtoChecksBallInLabel: {
    id: 'features.signatureAreaPage.rtoChecksBallInLabel',
    defaultMessage: 'Bail-in',
    description: 'Bail-in label',
  },
  rtoChecksIlliquidLabel: {
    id: 'features.signatureAreaPage.rtoChecksIlliquidLabel',
    defaultMessage: 'Illiquido',
    description: 'Illiquid label',
  },
  rtoChecksConflictOperationLabel: {
    id: 'features.signatureAreaPage.rtoChecksConflictOperationLabel',
    defaultMessage: 'Operazione in conflitto',
    description: 'Conflict operation label',
  },

  /** survery summary */

  surverySummaryConsentTextA: {
    id: 'features.signatureAreaPage.surverySummaryConsentTextA',
    defaultMessage:
      "Vi conferisco l'incarico, nei termini e alle condizioni qui contemplate, di prestare a mio favore il Servizio di:",
    description:
      'first part of text before the consent check box in the survey summary',
  },
  surverySummaryConsentTextB: {
    id: 'features.signatureAreaPage.surverySummaryConsentTextB',
    defaultMessage:
      "Consulenza con l'offerta di servizi di Investimento propri e la commercializzazione di quote e/o azioni di OICR propri e/o di terzi",
    description:
      'second part of text before the consent check box in the survey summary',
  },

  /** sign card home page */

  signCardLabelPartOne: {
    id: 'features.signatureAreaPage.signCardLabelPartOne',
    defaultMessage: 'Hai ',
    description: '',
  },

  signCardLabelPartTwo: {
    id: 'features.signatureAreaPage.signCardLabelPartTwo',
    defaultMessage: ' pratiche da firmare',
    description: '',
  },

  signCardEmptyLabelPartOne: {
    id: 'features.signatureAreaPage.signCardEmptyLabel',
    defaultMessage: 'Non hai pratiche',
    description: '',
  },

  signCardEmptyLabelPartTwo: {
    id: 'features.signatureAreaPage.signCardEmptyLabel',
    defaultMessage: 'da firmare',
    description: '',
  },
  cancelPracticeToastTitle: {
    id: 'features.signatureAreaPage.cancelPracticeToastTitle',
    defaultMessage: 'Annullamento pratica',
    description: '',
  },
  cancelPracticeToastDescription: {
    id: 'features.signatureAreaPage.cancelPracticeToastDescription',
    defaultMessage:
      'Gentile cliente, per annullare la pratica si prega di contattare il consulente finanziario di riferimento.',
    description: '',
  },
  signLabel: {
    id: 'features.signatureAreaPage.signLabel',
    defaultMessage: 'Firma',
    description: 'Sign label',
  },
  editAmlSurveryLabel: {
    id: 'features.signatureAreaPage.editAmlSurveryLabel',
    defaultMessage: 'Modifica questionari AML e FATCA-CRS',
    description: 'Edit AML and FACTA-CRS survery label',
  },
  editMifidSurveryLabel: {
    id: 'features.signatureAreaPage.editMifidSurveryLabel',
    defaultMessage: 'Modifica questionario MiFID',
    description: 'Edit MiFID survery label',
  },
  cancelPracticeLabel: {
    id: 'features.signatureAreaPage.cancelPracticeLabel',
    defaultMessage: 'Annulla la pratica',
    description: 'Cancel practice label',
  },
  rejectProposalDialogText: {
    id: 'features.signatureAreaPage.rejectProposalDialogText',
    defaultMessage: 'Sei sicuro di voler rifiutare la pratica?',
    description: '',
  },
  signedSucceededDialogText: {
    id: 'features.signatureAreaPage.signedSucceededDialogText',
    defaultMessage: 'Il processo di firma digitale si è concluso con successo',
    description: '',
  },
  signedFailedDialogText: {
    id: 'features.signatureAreaPage.signedFailedDialogText',
    defaultMessage: 'Il processo di firma digitale non è andato a buon fine',
    description: '',
  },
  /* disclaimer recompile questionnaire */
  disclaimerMifidSurveryTitle: {
    id: 'features.signatureAreaPage.disclaimerMifidSurveryLabel',
    defaultMessage: 'Modifica questionario MiFID',
    description: '',
  },
  disclaimerAMLSurveryTitle: {
    id: 'features.signatureAreaPage.disclaimerAMLSurveryText',
    defaultMessage: 'Modifica questionari AML e FATCA-CRS',
    description: '',
  },
  disclaimerRepeatQuestionnaireText: {
    id: 'features.signatureAreaPage.disclaimerRpeatQuestionnaireText',
    defaultMessage:
      'Cliccando su "ripeti questionario", l’attuale questionario sarà scartato e dovrai ricompilarlo',
    description: '',
  },
  repeatQuestionnaire: {
    id: 'features.signatureAreaPage.repeatQuestionnaire',
    defaultMessage: 'Ripeti questionario',
    description: '',
  },
  underProcessing: {
    id: 'features.signatureAreaPage.underProcessing',
    defaultMessage: 'in lavorazione...',
    description: '',
  },
  singlePracticeUnderProcessing: {
    id: 'features.signatureAreaPage.singlePracticeUnderProcessing',
    defaultMessage: '1 pratica in lavorazione...',
    description: '',
  },
  multiplePracticeUnderProcessing: {
    id: 'features.signatureAreaPage.multiplePracticeUnderProcessing',
    defaultMessage: '{practiceUnderProcessing} pratiche in lavorazione...',
    description: '',
  },
  kidLabel: {
    id: 'features.signatureAreaPage.kidLabel',
    defaultMessage: 'KID',
    description: '',
  },
});
